import { ContactType, PatientContact } from '../../../../../generated/graphql';

export const CONTACT_TYPE_LABELS: Record<ContactType, string> = {
  [ContactType.EmergencyContact]: 'Emergency Contact',
  [ContactType.Guardian]: 'Guardian',
  [ContactType.Custodian]: 'Custodian',
  [ContactType.Interpreter]: 'Interpreter',
  [ContactType.ParticipantSupportPerson]: 'Support Person',
  [ContactType.Therapist]: 'Therapist',
  [ContactType.Minor]: 'Minor',
  [ContactType.Other]: 'Other',
};

export const CONTACT_TYPE_OPTIONS: { label: string; value: ContactType }[] =
  Object.entries(CONTACT_TYPE_LABELS).map(([value, label]) => ({
    label,
    value: value as ContactType,
  }));

export interface ContactFormData {
  contactType: ContactType;
  firstName: string;
  lastName: string;
  email?: string;
  phoneNumber: string;
  addressStreet?: string;
  addressCity?: string;
  addressState?: string;
  addressPostalCode?: string;
  addressCountry?: string;
  relationshipDescription?: string;
}

export const getContactFullName = (
  contact: PatientContact | null | undefined,
): string => {
  if (!contact) return '';
  return [contact.firstName, contact.lastName].filter(Boolean).join(' ');
};

export const formatAddress = (
  contact: PatientContact | null | undefined,
): string | null => {
  if (!contact) return null;
  const parts = [
    contact.addressStreet,
    contact.addressCity,
    contact.addressState,
    contact.addressPostalCode,
    contact.addressCountry,
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(', ') : null;
};
